import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Settings, Wifi } from "lucide-react";

interface RPCSelectorProps {
  value: string;
  onValueChange: (value: string) => void;
}

export function RPCSelector({ value, onValueChange }: RPCSelectorProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className="h-12 bg-[#ffffff]/5 border-[#ffffff]/10 text-white hover:bg-[#ffffff]/[0.07] transition-colors">
        <SelectValue placeholder="Select RPC endpoint" />
      </SelectTrigger>
      <SelectContent className="bg-[#111111] border-[#ffffff]/10 text-white">
        <SelectItem value="devnet">
          <div className="flex items-center gap-2">
            <Wifi className="h-3.5 w-3.5 text-[#00D18C]" />
            Default Devnet RPC
          </div>
        </SelectItem>
        <SelectItem value="custom-devnet">
          <div className="flex items-center gap-2">
            <Settings className="h-3.5 w-3.5 text-[#9945FF]" />
            Custom Devnet RPC
          </div>
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
